import React, { Component } from "react";
import Axios from "axios";
import Container from "../../common/application_container";
import { getUser } from "../../../actions/session";
import { Notifications } from "../../common/notification";
import CustomLoader from "../../common/loader";
import CustomModal from "../../common/modal";
import { MEDIA_IP_BLOCK_LISTING } from "../../../config/rest_endpoints";
import Pagination from "react-js-pagination";

export default class MediaIPBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      User: getUser(),
      data: [],
      isGetting: false,
      addModal: false,
      editModal: false,
      deleteModal: false,
      editInfo: {},
      deleteId: "",
      deleteIp: "",
      ip: "",
      note: "",
      isLoad: false,
      searchIp: "",
      exportListData: [],
      exportListPage: 1,
      exportListLimit: 10,
      exportListTotalCount: 0,
      ipError: "",
    };
    this.openAddModal = this.openAddModal.bind(this);
    this.closeAddModal = this.closeAddModal.bind(this);
    this.openEditModal = this.openEditModal.bind(this);
    this.closeEditModal = this.closeEditModal.bind(this);
    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.getData = this.getData.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  openAddModal() {
    this.setState({ addModal: true, ip: "", note: "" });
  }

  closeAddModal() {
    this.setState({ addModal: false, ip: "", note: "", ipError: "" });
  }

  openEditModal(row) {
    this.setState({
      editModal: true,
      editInfo: row,
      ip: row.ip,
      note: row.note,
    });
  }

  closeEditModal() {
    this.setState({
      editModal: false,
      editInfo: {},
      ip: "",
      note: "",
      ipError: "",
    });
  }

  openDeleteModal(row) {
    console.log("row", row);
    this.setState({ deleteModal: true, deleteId: row.id, deleteIp: row.ip });
  }

  closeDeleteModal() {
    this.setState({ deleteModal: false, deleteId: "" });
  }

  // IP Address validation function
  validateIPAddress(ip) {
    // Regular expression for IPv4 validation
    const ipv4Regex =
      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

    if (!ip || ip.trim() === "") {
      return "IP address is required";
    }

    if (!ipv4Regex.test(ip.trim())) {
      return "Please enter a valid IP address (e.g., 192.168.1.1)";
    }

    return "";
  }

  getData(
    ip = this.state.searchIp,
    page = this.state.page,
    limit = this.state.limit
  ) {
    const { User } = this.state;
    this.setState({ isGetting: true });
    var headers = { Authorization: "Bearer " + User.token };
    let params = {};
    if (ip && ip.trim() !== "") params.ip = ip;
    params.page = page;
    params.limit = limit;
    Axios.get(MEDIA_IP_BLOCK_LISTING, { headers, params })
      .then((res) => {
        if (res) {
          this.setState({
            data: res.data.data,
            exportListTotalCount: res.data.pageinfo.totalCount,
            isGetting: false,
          });
        }
      })
      .catch((err) => {
        const alert = err.response;
        if (
          alert &&
          alert.data &&
          alert.data.message === "invalid or expired jwt"
        ) {
          localStorage.removeItem("user");
          Notifications.notify(alert.data.message, "Token Expire", "error");
        }
        Notifications.notify(
          alert && alert.data && alert.data.message
            ? alert.data.message
            : "Failed",
          "Failed",
          "error"
        );
        this.setState({ isGetting: false });
      });
  }

  handleSearchChange(e) {
    const value = e.target.value;
    this.setState({ searchIp: value }, () => {
      if (value.trim() === "") {
        this.setState({ exportListPage: 1 }, () => {
          this.getData("", 1, this.state.exportListLimit);
        });
      }
    });
  }

  handleSearch(e) {
    e.preventDefault();
    this.getData(this.state.searchIp, 1, this.state.limit);
  }

  handleExportListPageChange(pageNumber) {
    this.setState({ exportListPage: pageNumber }, () => {
      this.getData(this.state.searchIp, pageNumber, this.state.exportListLimit);
    });
  }

  async handleSubmit(e) {
    e.preventDefault();
    const { ip, note, User } = this.state;

    // Validate IP address
    const ipError = this.validateIPAddress(ip);
    if (ipError) {
      this.setState({ ipError });
      return;
    }

    this.setState({ isLoad: true, ipError: "" });
    var headers = { Authorization: "Bearer " + User.token };
    try {
      const response = await Axios.post(
        MEDIA_IP_BLOCK_LISTING,
        { ip, note },
        { headers }
      );
      // Use the message from backend response if available, otherwise use default message
      const successMessage =
        response.data && response.data.message
          ? response.data.message
          : "Media IP created successfully";
      Notifications.notify(successMessage, "Success", "success");
      this.closeAddModal();
      this.getData();
    } catch (err) {
      // Use error message from backend if available, otherwise use default message
      const errorMessage =
        err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : "Failed to create";
      Notifications.notify(errorMessage, "Failed", "error");
    }
    this.setState({ isLoad: false });
  }

  async handleEditSubmit(e) {
    e.preventDefault();
    const { ip, note, editInfo, User } = this.state;

    // Validate IP address
    const ipError = this.validateIPAddress(ip);
    if (ipError) {
      this.setState({ ipError });
      return;
    }

    this.setState({ isLoad: true, ipError: "" });
    var headers = { Authorization: "Bearer " + User.token };
    try {
      const response = await Axios.put(
        MEDIA_IP_BLOCK_LISTING,
        { id: editInfo.id, ip, note },
        { headers }
      );
      // Use the message from backend response if available, otherwise use default message
      const successMessage =
        response.data && response.data.message
          ? response.data.message
          : "Media IP updated successfully";
      Notifications.notify(successMessage, "Success", "success");
      this.closeEditModal();
      this.getData();
    } catch (err) {
      // Use error message from backend if available, otherwise use default message
      const errorMessage =
        err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : "Failed to update";
      Notifications.notify(errorMessage, "Failed", "error");
    }
    this.setState({ isLoad: false });
  }

  async handleDelete() {
    const { deleteId, User } = this.state;
    this.setState({ isLoad: true });
    var headers = { Authorization: "Bearer " + User.token };
    console.log("deleteId", deleteId);
    try {
      const response = await Axios.delete(
        `${MEDIA_IP_BLOCK_LISTING}/${deleteId}`,
        {
          headers,
        }
      );
      // Use the message from backend response if available, otherwise use default message
      const successMessage =
        response.data && response.data.message
          ? response.data.message
          : "Deleted successfully";
      Notifications.notify(successMessage, "Success", "success");
      this.closeDeleteModal();
      this.getData();
    } catch (err) {
      // Use error message from backend if available, otherwise use default message
      const errorMessage =
        err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : "Failed to delete";
      Notifications.notify(errorMessage, "Failed", "error");
    }
    this.setState({ isLoad: false });
  }

  renderTableRows() {
    const { data } = this.state;
    if (!data.length) {
      return (
        <tr>
          <td colSpan={5} className="text-center">
            No entries found
          </td>
        </tr>
      );
    }
    return data.map((item, idx) => (
      <tr key={item.id || idx}>
        <td className="text-center">{item.ip}</td>
        <td className="text-center">{item.note}</td>
        <td className="text-center">
          {item.createDate ? new Date(item.createDate).toLocaleString() : ""}
        </td>
        <td className="text-center">
          {item.updateDate ? new Date(item.updateDate).toLocaleString() : ""}
        </td>
        <td
          style={{ textAlign: "center", fontSize: "20px" }}
          className="edit-button"
        >
          <i
            className="fa fa-edit mr-2"
            onClick={this.openEditModal.bind(this, item)}
          ></i>
          <i
            className="fa fa-trash text-danger"
            aria-hidden="true"
            onClick={this.openDeleteModal.bind(this, item)}
          ></i>
        </td>
      </tr>
    ));
  }

  render() {
    const {
      addModal,
      editModal,
      deleteModal,
      ip,
      note,
      isLoad,
      isGetting,
      deleteIp,
      searchIp,
      exportListPage,
      exportListLimit,
      exportListTotalCount,
      ipError,
    } = this.state;
    console.log("deleteIp", deleteIp);

    let addModalConfig = {
      details: {
        info: "Create Media IP",
        msg: (
          <form onSubmit={this.handleSubmit}>
            <div className="form-group">
              <label>IP</label>
              <input
                type="text"
                className={`form-control ${ipError ? "is-invalid" : ""}`}
                placeholder="e.g., 192.168.1.1"
                value={ip}
                onChange={(e) =>
                  this.setState({ ip: e.target.value, ipError: "" })
                }
                required
              />
              {ipError && <div className="invalid-feedback">{ipError}</div>}
            </div>
            <div className="form-group">
              <label>Note</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Note"
                value={note}
                onChange={(e) => this.setState({ note: e.target.value })}
              />
            </div>
            <div className="text-right">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isLoad}
              >
                {isLoad ? "Saving..." : "Create"}
              </button>
            </div>
          </form>
        ),
      },
      confirmBtn: { label: "Update", action: "" },
      cancelBtn: { label: "Cancel", action: this.closeAddModal },
      crossBtn: { action: this.closeAddModal },
    };

    let editModalConfig = {
      details: {
        info: "Update Media IP",
        msg: (
          <form onSubmit={this.handleEditSubmit}>
            <div className="form-group">
              <label>IP</label>
              <input
                type="text"
                className={`form-control ${ipError ? "is-invalid" : ""}`}
                value={ip}
                onChange={(e) =>
                  this.setState({ ip: e.target.value, ipError: "" })
                }
                required
              />
              {ipError && <div className="invalid-feedback">{ipError}</div>}
            </div>
            <div className="form-group">
              <label>Note</label>
              <input
                type="text"
                className="form-control"
                value={note}
                onChange={(e) => this.setState({ note: e.target.value })}
                required
              />
            </div>
            <div className="text-right">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isLoad}
              >
                {isLoad ? "Saving..." : "Update"}
              </button>
            </div>
          </form>
        ),
      },
      cancelBtn: { label: "Cancel", action: this.closeEditModal },
      crossBtn: { action: this.closeEditModal },
    };

    let deleteModalConfig = {
      details: {
        info: "Delete Media IP",
        msg: (
          <div>
            <h4>
              Are you sure you want to delete this Media <b>{deleteIp}</b>?
            </h4>
            <div className="text-right">
              <button
                type="button"
                className="btn btn-danger mt-3"
                onClick={this.handleDelete}
                disabled={isLoad}
              >
                {isLoad ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        ),
      },
      cancelBtn: { label: "Cancel", action: this.closeDeleteModal },
      crossBtn: { action: this.closeDeleteModal },
    };

    return (
      <Container
        title="Media IP Block"
        title1="Section"
        icon="fas fa-phone-slash"
      >
        <CustomModal
          visibility={addModal}
          customBodyCSS={"h20"}
          modalType={"success"}
          details={addModalConfig.details}
          modalSize={"modal-md"}
          showBtns={false}
          cancelBtn={addModalConfig.cancelBtn}
          crossBtn={addModalConfig.crossBtn}
        />

        <CustomModal
          visibility={editModal}
          customBodyCSS={"h20"}
          modalType={"success"}
          details={editModalConfig.details}
          modalSize={"modal-md"}
          showBtns={false}
          cancelBtn={editModalConfig.cancelBtn}
          crossBtn={editModalConfig.crossBtn}
        />

        <CustomModal
          visibility={deleteModal}
          customBodyCSS={"h20"}
          modalType={"danger"}
          details={deleteModalConfig.details}
          modalSize={"modal-md"}
          showBtns={false}
          cancelBtn={deleteModalConfig.cancelBtn}
          crossBtn={deleteModalConfig.crossBtn}
        />

        <div className="d-flex justify-content-between align-items-center mb-3">
          <form className="form-inline" onSubmit={this.handleSearch}>
            <input
              type="text"
              className="form-control mr-2"
              placeholder="Search by IP"
              value={searchIp}
              onChange={this.handleSearchChange}
            />
            <button
              type="submit"
              className="btn btn-primary btn-sm"
              disabled={isGetting}
            >
              {isGetting && (
                <i className="fa fa-spinner fa-spin mr-2" aria-hidden="true"></i>
              )}
              Filter
            </button>
          </form>
          <button
            type="button"
            className="main-button btn btn-success btn-sm ml-3"
            onClick={this.openAddModal}
          >
            Media IP Create <i className="fas fa-plus ml-2"></i>
          </button>
        </div>

        <div
          style={{
            border: "none",
            borderRadius: "5px",
            boxShadow: "0 0 20px rgba(0,0,0,.08)",
          }}
          className="card card-body"
        >
          <div
            id="DataTables_Table_0_wrapper"
            className="dataTables_wrapper no-footer"
          >
            <div className="datatable-scroll" style={{ overflowX: "auto" }}>
              <table
                className="table-style table table-striped dataTable no-footer"
                id="DataTables_Table_0"
                role="grid"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead>
                  <tr className="stickeyHeader table-heading-style">
                    <th className="text-center">IP</th>
                    <th className="text-center">Note</th>
                    <th className="text-center">Created Date</th>
                    <th className="text-center">Updated At</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.isGetting ? (
                    <CustomLoader />
                  ) : (
                    this.renderTableRows()
                  )}
                </tbody>
              </table>
            </div>
            {/* --- Pagination Controls --- */}
            <div className="datatable-footer mt-1">
              <Pagination
                activePage={exportListPage}
                itemsCountPerPage={exportListLimit}
                totalItemsCount={exportListTotalCount}
                pageRangeDisplayed={5}
                onChange={this.handleExportListPageChange.bind(this)}
              />
            </div>
          </div>
        </div>
      </Container>
    );
  }
}
